import { Button } from '@klear/ui/components/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@klear/ui/components/card'
import { useNavigate } from 'react-router'
import klearLogo from '@/assets/logo-klear.png'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

export default function NotFound() {
  useDocumentTitle('Page Not Found')
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <a href="/">
        <img
          alt="Klear Logo"
          width="180"
          height="48"
          decoding="async"
          data-nimg="1"
          className="h-12 w-auto mb-8 dark:invert"
          src={klearLogo}
          style={{ color: 'transparent' }}
        />
      </a>
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Page Not Found</CardTitle>
          <CardDescription>Sorry, we couldn&apos;t find the page you&apos;re looking for.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button className="w-full" onClick={() => navigate(-1)}>
            Go back
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
